import getDateDiffFromNow, {
  getDateFromTimeStamp,
  getTimeFromTimeStamp,
} from './getDateDiffFromNow';
import {
  getKeyValsFromObjArr,
  getLowerCaseString,
} from './getKeyValsFromObjArr';
import getSection from './getSection';
import { PAID_ARTICLE_PRIME_ID } from '../../../constants';

const getGa4PageViewEventObj = (
  pageData = {},
  params = {},
  overrideObj = {},
) => {
  const {
    ag,
    id,
    metaInfo = {},
    dl,
    authors = [],
    navsubsecs = {},
    seo = {},
    primeId,
  } = pageData;

  const {
    pageTemplate,
    isMobile,
    perpetual = false,
    pagination,
    channelName,
  } = params;
  const {
    subsecname1 = '',
    subsecnameseo2 = '',
    subsecnameseo3 = '',
  } = getSection(navsubsecs);
  const sectionName = subsecname1.toLowerCase();
  const subSectionName = subsecnameseo2.toLowerCase();
  const subSectionName2 = subsecnameseo3.toLowerCase();

  const notAvailable = 'N/A';

  let ga4PageViewParams = {
    event: 'page_view',
    page_template: pageTemplate,
    agency: getLowerCaseString(ag) || notAvailable,
    section: getLowerCaseString(sectionName) || notAvailable,
    subsection: getLowerCaseString(subSectionName) || notAvailable,
    subsection2: getLowerCaseString(subSectionName2) || notAvailable,
    msid: id,
    keywords: seo.keywords,
    content_type: metaInfo.Contenttype || notAvailable,
    browsing_client: 'web',
    browsing_platform: isMobile ? 'mweb' : 'web',
    business_property: channelName || 'toi',
    page_stack: 'react',
    perpetual,
    pagination: pagination || notAvailable,
    days_since_created: dl !== '' ? getDateDiffFromNow(dl) : notAvailable,
    authors:
      getLowerCaseString(getKeyValsFromObjArr(authors, 'name', ',')) ||
      notAvailable,
    page_version: notAvailable,
    meta_tag: seo.keywords,
    prime_content: !!params.isToipLayout,
    is_paywalled: primeId === PAID_ARTICLE_PRIME_ID && !params.isPrime,
    published_time: dl !== '' ? getTimeFromTimeStamp(dl) : notAvailable,
    published_date: dl !== '' ? getDateFromTimeStamp(dl) : notAvailable,
    section_full:
      getLowerCaseString(
        [sectionName, subSectionName, subSectionName2]
          .filter(Boolean)
          .join('_'),
      ) || notAvailable,
    category_tag: params.categorytabsmetainfo
      ? getLowerCaseString(params.categorytabsmetainfo)
      : notAvailable,
  };
  ga4PageViewParams = { ...overrideObj, ...ga4PageViewParams };
  return ga4PageViewParams;
};

export default getGa4PageViewEventObj;
